import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import classnames from "classnames";
import "./styles.scss";

class InputDate extends Component {
  // eslint-disable-line react/prefer-stateless-function
  render() {
    const {
      date,
      active,
      onClick,
      label,
      intl: { formatDate },
    } = this.props;
    const isActive = classnames({ "is-active": active });
    return (
      <div className={classnames("InputDate", isActive)} onClick={onClick}>
        <span className={classnames("InputDate-dateContainer", isActive)}>
          {date && (
            <span className={classnames("InputDate-weekDay", isActive)}>
              {formatDate(date, { weekday: "short" }).substring(0, 3)}
            </span>
          )}
          {date && (
            <span className={classnames("InputDate-date", isActive)}>
              {formatDate(date, { day: "2-digit" })}{" "}
              {formatDate(date, { month: "short" }).substring(0, 3)}
              <span className={"InputDate-Year"}>
                {" " + formatDate(date, { year: "numeric" })}
              </span>
            </span>
          )}
          {!date && <span className={classnames("InputDate-date", isActive)}>{label}</span>}
        </span>
      </div>
    );
  }
}

InputDate.propTypes = {
  date: PropTypes.instanceOf(Date),
  active: PropTypes.bool,
  onClick: PropTypes.func,
  onClean: PropTypes.func,
  onChange: PropTypes.func,
  label: PropTypes.string,
  intl: PropTypes.object,
  fullWidth: PropTypes.bool,
};

InputDate.defaultProps = {
  onClick() {},
  onClean() {},
  active: false,
};

export default injectIntl(InputDate);
